// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { BEComponent } from './BEComponent';
import { BEServiceAction } from './BEServiceAction';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 服务 实体类
 * 对外暴露的服务
 */
export class BEService extends BETypeElement {
  /** 是否需登录 : 是否需登录，true代表只能登录后才能访问 */
  private _needLogin: boolean;

  /** 设置：是否需登录 */
  public get needLogin() {
    return this._needLogin;
  }

  /** 获取：是否需登录 */
  public set needLogin(value: boolean) {
    this._needLogin = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 服务操作 */
  private _serviceActions: Array<BEServiceAction>;

  /** 获取：服务操作 */
  public get serviceActions() {
    return this._serviceActions;
  }

  /** 设置：服务操作 */
  public set serviceActions(value: Array<BEServiceAction>) {
    this._serviceActions = value;
  }

  constructor() {
    super();
    this._needLogin = true;
    this._component_ID = '';
    this._component = null;
    this._serviceActions = new Array<BEServiceAction>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEService, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.needLogin = element.needLogin;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.needLogin = json.NeedLogin;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.ServiceActions && json.ServiceActions.length > 0) {
      json.ServiceActions.forEach((element: any) => {
        const bEServiceAction = BEServiceAction.Create(element);
        // bEServiceAction.service = this;
        this.serviceActions.push(bEServiceAction);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.NeedLogin = this.needLogin;
    json.Component_ID = this.component_ID;
    if (this.serviceActions && this.serviceActions.length > 0) {
      json.ServiceActions = [];
      this.serviceActions.forEach((element) => {
        json.ServiceActions.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'needLogin', '是否需登录', EnumDataType.Bool, this.needLogin, true, '是否需登录，true代表只能登录后才能访问', '', '');
    return context;
  }

  static Create(json: any): BEService {
    const bEService = new BEService();
    bEService.Deserialize(json);
    bEService.json = json;
    return bEService;
  }
}
